import LinearProgress from '@mui/material/LinearProgress';

export default function LinearIndeterminate() {
  return (
      <LinearProgress />
  );
}